<template>
    <div class="check-clubcard-token-form">
        <form @submit.prevent="search()">
            <div class="input-group-flex">
                <input ref="input"
                       class="form-control input-xl"
                       data-testid="clubcard-search-input"
                       :placeholder="inputPlaceholder"
                       :value="ref"
                       :disabled="!isOnline"
                       @input="onInput" />
                <SquareBtn :color="btnColor"
                           :disabled="!isOnline || !ref"
                           data-testid="clubcard-search-btn"
                           size="xl"
                           class="btn--inline-flex"
                           :loading="searching"
                           @click="search">
                    {{ l('SEARCH_MODAL.SEARCH') }}
                </SquareBtn>
                <SquareBtn :disabled="!isOnline || !ref"
                           data-testid="clubcard-clear-btn"
                           size="xl"
                           class="btn--inline-flex btn-white"
                           :loading="searching"
                           @click="reset">
                    {{ l('CLEAR') }}
                </SquareBtn>
            </div>
        </form>

        <ClubcardTokenStatus v-if="token"
                             class="mt-1"
                             :token="token"></ClubcardTokenStatus>
        <div v-else-if="error"
             class="alert alert-danger mt-1">
            <i class="fa-solid fa-circle-xmark"></i> {{ error }}
        </div>
    </div>
</template>

<script>
import ClubcardTokenStatus from '@/epos/vue/modals/Search/ClubcardTokenStatus';
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { mapState } from 'vuex';

export default {
    name: 'CheckClubcardTokenForm',

    components: {
        ClubcardTokenStatus,
        SquareBtn,
    },

    props: {
        btnColor: {
            type: String,
            default: 'primary',
        },
    },

    emits: [
        'loaded',
    ],

    data() {
        return {
            searching: false,

            ref: '',

            /**
             * @type {ClubcardToken|null}
             */
            token: null,

            /**
             * @type {string|null}
             */
            error: null,
        };
    },

    computed: {
        ...mapState(['isOnline']),

        inputPlaceholder() {
            return container.langService.getText('SEARCH_MODAL.CLUBCARD_TOKEN_INPUT_PLACEHOLDER');
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.input.focus();
        });
    },

    methods: {
        reset() {
            this.ref = '';
            this.setToken(null);
            this.error = null;
            this.$refs.input.focus();
        },

        /**
         * @param {InputEvent} evt
         */
        onInput(evt) {
            this.ref = evt.target.value;
        },

        /**
         * @param {ClubcardTokenWithItems|null} tokenWithItems
         */
        setToken(tokenWithItems) {
            this.token = tokenWithItems ? tokenWithItems.token : null;
            this.$emit('loaded', tokenWithItems);
        },

        search() {
            this.setToken(null);
            this.error = null;
            this.searching = true;

            container.clubcardService
                .validateUKToken(this.ref)
                .then((tokenWithItems) => {
                    this.setToken(tokenWithItems);
                })
                .catch((error) => {
                    console.error(error);
                    if (error.response?.data?.response?.message) {
                        this.error = error.response.data.response.message;
                    } else {
                        this.error = error.message;
                    }
                })
                .finally(() => {
                    this.searching = false;
                });
        },
    },
};
</script>
